// components/tasks/TaskItem.js
import React from 'react';

const TaskItem = ({ task, onToggle, disabled, hasChange }) => {
  const cls = [
    'ta-task-row',
    task.state.checked ? 'complete' : 'incomplete',
    hasChange ? 'pending' : '',
    disabled && task.state.checked ? 'immutable' : '',
    disabled && !task.state.checked ? 'cannot-complete' : ''
  ].filter(Boolean).join(' ');

  return (
    <div className={cls}>
      <span
        className="check"
        onClick={() => !disabled && onToggle(task.id)}
      ></span>
      <span className="task-name">{task.name}</span>
      {task.state.checked && task.state.date && (
        <span className="task-meta">
          <span className="date">{task.state.date}</span>
          <span className="by">{task.state.user}</span>
        </span>
      )}
    </div>
  );
};

export default TaskItem;
